import {
  Component,
  OnInit,
  OnChanges,
  Input,
  EventEmitter,
  Output,
  ElementRef,
} from '@angular/core'
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { AuthService, GlobalMessageService } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { QuoteCheckoutService } from '../../services/quote-checkout.service'
import { QuoteDataService } from '../../services/quote-data.service'

import { filter, take } from 'rxjs/operators'
import { CommonService } from '../../../../../shared/services/common.service'
import { DialogBoxService } from '../../../../../shared/dialog-box/dialog-box.service'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../config/dialog.config'
@Component({
  standalone: false,
  selector: 'vs-compliance-questions',
  templateUrl: './compliance-questions.component.html',
  styleUrls: ['./compliance-questions.component.scss'],
})
export class ComplianceQuestionsComponent implements OnInit, OnChanges {
  @Input() complienceQuestions
  @Input() isSubmitted
  @Input() loggedIn
  @Input() warningFlagText = ''
  @Output() complienceQuestionsUpdates = new EventEmitter<any>()
  @Output() warningFlagTextUpdate = new EventEmitter<any>()
  isEndUserSame = false
  Entity: any
  selectedCountry: any
  exportComplianceForm: FormGroup
  billToValidation: boolean
  endUserValidation: boolean
  deliveryValidation: boolean
  warningMsgFlagText = null
  userType: string
  cartId: any
  allQuestions: any
  allQuestions$: Observable<any>
  filesCount = 0
  restrictedCountryFlag: boolean
  autoFillFlag: boolean

  constructor(
    private formBuilder: FormBuilder,
    private quoteDataService: QuoteDataService,
    private el: ElementRef,
    private quoteCheckoutService: QuoteCheckoutService,
    private globalMessageService: GlobalMessageService,
    private auth: AuthService,
    private commonService: CommonService,
    private launchDialogService: LaunchDialogService,
    private dialogBoxService: DialogBoxService
  ) {
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
      this.cartId = sessionStorage.getItem('cartId-' + this.userType)
      const apiUrl = this.commonService.constructUrl([
        'vsExportCompliance',
        this.cartId,
        'questions',
      ])
      this.allQuestions$ = this.quoteCheckoutService.getQuestions(this.cartId)

      this.allQuestions$.subscribe((data) => {
        // this.allQuestions = export_questions;
        this.allQuestions = data
        if (this.complienceQuestions) {
          this.allQuestions.vsExportComplianceQuestions.forEach((question) => {
            this.exportComplianceForm.controls[question.questionId].setValue(
              this.complienceQuestions[question.questionId]
            )
          })
          this.quoteDataService.sendComplieneceValidation(
            this.exportComplianceForm.valid
          )
        }
      })
    })
    this.exportQuestionFormDetails()
  }

  autoFill() {
    const componentdata = {}

    const autoFillNoDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.AUTOFILL_NO,
      undefined,
      undefined,
      componentdata
    )
    if (autoFillNoDialog) {
      autoFillNoDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.AUTOFILL_NO
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'confirm-autofill') {
            this.dialogBoxService.autoFillData.next(true)
            if (this.complienceQuestions) {
              this.allQuestions.vsExportComplianceQuestions.forEach(
                (question) => {
                  this.exportComplianceForm.controls[
                    question.questionId
                  ].setValue(false)
                }
              )
              this.quoteDataService.sendComplieneceValidation(
                this.exportComplianceForm.valid
              )
            }
          }
        })
    }
  }
  ngOnInit(): void {
    // this.quoteDataService.setComplianceQuestionData
    this.quoteDataService.recieveBillToAddressValidation.subscribe(
      (valid: boolean) => {
        this.billToValidation = valid
      }
    )
    this.quoteDataService.recieveEndUserAddressValidation.subscribe(
      (valid: boolean) => {
        this.endUserValidation = valid
      }
    )
    this.quoteDataService.recieveDeliveryAddressValidation.subscribe(
      (valid: boolean) => {
        this.deliveryValidation = valid
      }
    )

    this.exportComplianceForm.valueChanges.subscribe((data) => {
      this.quoteDataService.sendComplieneceValidation(
        this.exportComplianceForm.valid
      )
      this.complienceQuestionsUpdates.emit(data)
    })
    this.quoteCheckoutService.checkSubmission.subscribe((data) => {
      this.isSubmitted = data
      if (
        data === true &&
        this.billToValidation &&
        this.deliveryValidation &&
        this.endUserValidation
      ) {
        try {
          this.allQuestions.vsExportComplianceQuestions.forEach((question) => {
            if (
              this.exportComplianceForm.controls[question.questionId].invalid
            ) {
              this.scrollIntoView('#' + question.questionId + 'Error')
              throw 'stop'
            }
          })
        } catch (e) {}
        // this.scrollToError();
      }
    })
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      el.parentElement.focus()
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    )
    this.scrollTo(firstElementWithError)
  }
  scrollIntoView(el) {
    if (el != null) {
      document
        .querySelector(el)
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
  ngOnChanges(changes) {}
  exportQuestionFormDetails() {
    this.exportComplianceForm = this.formBuilder.group({
      sanctionCheck: new FormControl(null, Validators.required),
      restrictedCountryCheck: new FormControl(null, Validators.required),
      customerReviewCheck: new FormControl(null, Validators.required),
      isNuclear: new FormControl(null, Validators.required),
      hasRestrictedUse: new FormControl(null, Validators.required),
      requiresExportLicense: new FormControl(null, Validators.required),
      restrictedPartList: new FormControl(null, Validators.required),
      warningFlags: new FormControl(null, Validators.required),
      governmentParties: new FormControl(null, Validators.required),
    })
  }
  setValue(questionId, value) {
    this.exportComplianceForm.controls[questionId].setValue(value)
    this.quoteDataService.setCompliancequestionData(
      this.exportComplianceForm.value
    )
    if (
      questionId == 'restrictedPartList' ||
      questionId == 'governmentParties'
    ) {
      if (value == true) {
        this.filesCount++
        this.quoteCheckoutService.sendFilesCount(this.filesCount)
      } else if (value == false) {
        if (this.filesCount > 0) {
          this.filesCount--
        }
        this.quoteCheckoutService.sendFilesCount(this.filesCount)
      }
    }
  }

  getEntity() {
    if (this.Entity === this.selectedCountry) {
      this.isEndUserSame = true
    } else {
      this.isEndUserSame = false
    }
  }
  warningFlagTextChange() {
    this.warningFlagTextUpdate.emit(this.warningFlagText)
  }
}
